// Build weight estimate from the sourced component weights (server/component-weights.json).
// Tyres and bottle cages are listed per piece and fitted in pairs, like their prices.
const PAIRS = ['tyres', 'cages'];

// Every build needs parts the steps don't model: bar tape, headset, thru-axles,
// seat clamp, valves and tubeless sealant. Pedals count only when chosen.
export const SMALL_PARTS = { grams: 280, tolerance: .3 };

function widthsOf(item) {
  if (!item.weightWidths) return null;
  try { return typeof item.weightWidths === 'string' ? JSON.parse(item.weightWidths) : item.weightWidths; }
  catch (e) { return null; }
}

export function partWeight(entry) {
  const item = entry && entry.item;
  if (!item) return null;
  if (item.noCages || item.noPedals) return { grams: 0, each: 0, count: 0, tolerance: 0 };
  let each = item.weightGrams;
  const widths = entry.props && entry.props.id === 'tyres' && entry.tyreWidth && widthsOf(item);
  if (widths) {
    const exact = widths[String(entry.tyreWidth)] || widths[String(Math.round(entry.tyreWidth))];
    if (exact) each = exact;
  }
  if (each == null || !(each >= 0)) return null;
  // A colour can change the part itself (e.g. a frameset sold with a suspension fork).
  const choice = item.colors && item.colors[entry.color];
  const delta = choice && choice.color && choice.color.weightDeltaGrams;
  if (delta) each += delta;
  const count = entry.props && PAIRS.includes(entry.props.id) ? 2 : 1;
  return { grams: each * count, each, count, tolerance: item.weightTolerance || .05 };
}

// Uncertainties are independent, so they add in quadrature.
export function buildWeight(composition = []) {
  const parts = composition.map(entry => ({ entry, weight: partWeight(entry) }));
  const known = parts.filter(part => part.weight);
  if (!known.length) return null;
  let grams = SMALL_PARTS.grams;
  let variance = Math.pow(SMALL_PARTS.grams * SMALL_PARTS.tolerance, 2);
  for (const { weight } of known) {
    grams += weight.grams;
    variance += Math.pow(weight.grams * weight.tolerance, 2);
  }
  const spread = Math.sqrt(variance);
  return {
    grams, low: grams - spread, high: grams + spread,
    missing: parts.filter(part => !part.weight).map(part => part.entry.item.name),
    pedals: known.some(({ entry, weight }) => entry.props && entry.props.id === 'pedals' && weight.grams > 0)
  };
}

export function kg(grams, digits = 1) {
  return (grams / 1000).toFixed(digits);
}

export function weightLabel(grams) {
  return grams >= 1000 ? `${kg(grams, 2)} kg` : `${Math.round(grams)} g`;
}
